export default {
  memberKey: 'rdfs:subClassOf'
  modelGraph: 'model-0'

  actionsPages: [{
      key: 'clear-space'
      title: 'Clear Space'
      component: 'clear_space'
  }, {
    key: 'upload-excel'
    title: 'Upload Excel'
    component: 'upload_file'
    service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['leomodel'], config: { wipe: false }  }
  }, {
    key: 'generate-turtle'
    title: 'Generate Turtle'
    component: 'generate_file'
    service: { name: 'rdf-export-service', call: 'historyToRdf', config: {rdlVersion: '8.0.0', iimVersion: '5.0.0'} }
  }]

  nameKeys: [
    'name'
  ]

  disabledRelations: [
    'rdfs:domain'
    'rdfs:range'
  ]

  groupings: []
  queries: []
}
